import React from 'react';
import { FILTER } from '@fiverr-private/listing_lib';
import { filterType } from '../../../../../../../types';
import Toggle, { TogglePropTypes } from '../toggle';

const ProToggle = ({ filter, usePillButton, ...rest }) => {
    if (!filter) {
        return null;
    }

    const titleKey = usePillButton
        ? 'search_perseus.filters.global.pro.filter_row_alias'
        : 'search_perseus.filters.global.pro.alias';

    return (
        <Toggle
            selectedValue={FILTER.PRO.SELECTED_VALUE}
            title={titleKey}
            text="search_perseus.filters.global.pro.text"
            {...filter}
            {...rest}
            usePillButton={usePillButton}
        />
    );
};

ProToggle.propTypes = {
    filter: filterType,
    ...TogglePropTypes,
};

export default ProToggle;
